export const BOOKING_EDIT_STATUS = [
  'UNPAID',
  'PAID',
  'REFUND',
  'PARTIAL_REFUND',
  'EXPIRED',
  'CANCELED',
  // 'RESCHEDULED'
]
